<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Summary & Performance Report Lebanon") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
                  ? 'shift-up'
                  : ''
                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
              <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
                :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
                @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="getSummaryPerformanceData()">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title">Summary Report</div>

        <div v-if="Object.keys(summaryData).length ||
          Object.keys(boxOfficeData).length ||
          Object.keys(concessionData).length
          " class="mr-3 align-self-center d-flex justify-content-end align-items-center">
          <div class="mx-1">{{ $t("download") }} as:</div>
          <a target="_blank" @click="getSummaryReport('Y')" title="Download as PDF" download>
            <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <div class="mx-2 row">
        <div class="col-4 border border-1 border-dark py-2  ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Summary</div>

          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">Total Admits :</td>

              <td class="text-right small px-1">{{
                summaryData.total_admits ? summaryData.total_admits : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total Transactions :</td>

              <td class="text-right small px-1">{{
                summaryData.total_transactions
                ? summaryData.total_transactions
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total Seats In Cinema :</td>

              <td class="text-right small px-1">{{
                summaryData.total_seats_in_cinema
                ? summaryData.total_seats_in_cinema
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total Screen :</td>

              <td class="text-right small px-1">{{
                summaryData.total_screen ? summaryData.total_screen : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total No of Shows :
              </td>

              <td class="text-right small px-1">{{
                summaryData.total_no_of_shows
                ? summaryData.total_no_of_shows
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small  font-weight-bold px-1">Avg. of Shows :</td>

              <td class="text-right small px-1">{{
                summaryData.avg_shows ? currFormat(summaryData.avg_shows) : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total Capacity Available :
              </td>

              <td class="text-right small px-1">{{
                summaryData.total_capacity_available
                ? summaryData.total_capacity_available
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold px-1">Total Revenue :</td>

              <td class="text-right small px-1">{{
                summaryData.total_capacity_available
                ? currFormat(summaryData.total_revenue_conv)
                : 0
              }}</td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2 ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Box Office
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold px-1">Box Office Revenue(BOR) :</td>

              <td class="text-right small px-1">{{
                boxOfficeData.bo_revenue_conv
                ? currFormat(boxOfficeData.bo_revenue_conv)
                : 0
              }}</td>
            </tr>

            <template v-if="boxOfficeData.transactionTaxData &&
                boxOfficeData.transactionTaxData.length
                ">
              <tr v-for="(taxData,
                taxDataIndex) in boxOfficeData.transactionTaxData" :key="taxDataIndex">
                <td class="text-left small font-weight-bold px-1">{{ taxData.charge_type_name }} :</td>
                <td class="text-right small px-1">{{
                  currFormat(taxData.tax_value_conv)
                }}</td>
              </tr>
            </template>
            <tr>
              <td class="text-left small font-weight-bold px-1">Service Charge :</td>
              <td class="text-right small px-1">{{
                currFormat(boxOfficeData.service_charge_conv)
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Add. Chgs (Addl. Tax / FDF) :</td>
              <td class="text-right small px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Net BOR : </td>
              <td class="text-right small px-1">{{
                boxOfficeData.net_bor_conv
                ? currFormat(boxOfficeData.net_bor_conv)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Transaction :</td>
              <td class="text-right small px-1">{{
                boxOfficeData.total_transactions
                ? boxOfficeData.total_transactions
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold px-1">ATP :</td>
              <td class="text-right small px-1">{{
                boxOfficeData.atp_conv ? currFormat(boxOfficeData.atp_conv) : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold px-1">Net ATP :</td>
              <td class="text-right small px-1">{{
                boxOfficeData.net_atp_conv
                ? currFormat(boxOfficeData.net_atp_conv)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Occupancy :</td>
              <td class="text-right small px-1">{{
                boxOfficeData.occupancy
                ? currFormat(boxOfficeData.occupancy)
                : 0
              }}</td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2  ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Concessions
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small  font-weight-bold px-1">Gross Revenue :</td>

              <td class="text-right small px-1">{{
                concessionData.gross_revenue_conv
                ? currFormat(concessionData.gross_revenue_conv)
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small  font-weight-bold px-1">VAT :</td>
              <td class="text-right small px-1">{{
                concessionData.vat_conv
                ? currFormat(concessionData.vat_conv)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold px-1">Concession Net Revenue :</td>
              <td class="text-right small px-1">{{
                concessionData.concession_net_revenue_conv
                ? currFormat(concessionData.concession_net_revenue_conv)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Spend Per Head :</td>
              <td class="text-right small px-1">{{
                concessionData.gross_revenue_conv && summaryData.total_admits
                ? currFormat(
                  concessionData.gross_revenue_conv /
                  summaryData.total_admits
                )
                : 0
              }}
              </td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold px-1">Cost of Goods Sold :
              </td>
              <td class="text-right small px-1">{{
                concessionData.cost_goods_sold_conv
                ? currFormat(concessionData.cost_goods_sold_conv)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold px-1">Food Cost :</td>
              <td class="text-right px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Transactions :
              </td>
              <td class="text-right small px-1">{{
                concessionData.transactions ? concessionData.transactions : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Admission Strike Rate :</td>
              <td class="text-right small px-1">{{
                concessionData.gross_revenue_conv &&
                summaryData.total_transactions
                ? currFormat(
                  concessionData.gross_revenue_conv /
                  summaryData.total_transactions
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small bold-text font-weight-bold px-1">Average. Value Per Transaction :</td>
              <td class="text-right small  px-1">{{
                concessionData.gross_revenue_conv && concessionData.transactions
                ? currFormat(
                  concessionData.gross_revenue_conv /
                  concessionData.transactions
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  bold-text font-weight-bold px-1">Quantity of Item Sold :</td>
              <td class="text-right small px-1">{{
                concessionData.qty_items_sold
                ? concessionData.qty_items_sold
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small  bold-text font-weight-bold px-1" style="white-space: nowrap;">Average. Cost Per
                Admits :</td>
              <td class="text-right small px-1" style="white-space: nowrap;">{{
                concessionData.cost_goods_sold_conv && summaryData.total_admits
                ? currFormat(
                  concessionData.cost_goods_sold_conv /
                  summaryData.total_admits
                )
                : 0
              }}</td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2 ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Performance
            Indicators</div>
          <table class="swc-report-table border border-0 ">
            <tr>
              <td class="text-left small  font-weight-bold px-1">Items Per Admit :</td>
              <td class="text-right small px-1">{{
                concessionData.qty_items_sold && summaryData.total_admits
                ? currFormat(
                  concessionData.qty_items_sold / summaryData.total_admits
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Items Per Transaction :</td>
              <td class="text-right small px-1">{{
                concessionData.qty_items_sold && concessionData.transactions
                ? currFormat(
                  concessionData.qty_items_sold /
                  concessionData.transactions
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Transaction Strike Rate :</td>
              <td class="text-right px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Gross Box Revenue Per Seat :</td>
              <td class="text-right small px-1">{{
                summaryData.total_capacity_available &&
                summaryData.total_revenue_conv
                ? currFormat(
                  summaryData.total_revenue_conv /
                  summaryData.total_capacity_available
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Nett Box Revenue Per Seat :</td>
              <td class="text-right small px-1">{{
                boxOfficeData.net_bor_conv &&
                summaryData.total_capacity_available
                ? currFormat(
                  boxOfficeData.net_bor_conv /
                  summaryData.total_capacity_available
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Total Revenue Per Seat :</td>
              <td class="text-right px-1">{{
                summaryData.total_revenue_conv &&
                summaryData.total_capacity_available
                ? currFormat(
                  summaryData.total_revenue_conv /
                  summaryData.total_capacity_available
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Average Sale Per Transaction :</td>
              <td class="text-right small px-1">{{
                summaryData.total_revenue_conv && summaryData.total_transactions
                ? currFormat(
                  summaryData.total_revenue_conv /
                  summaryData.total_transactions
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold px-1">Average Sale Per Patron :</td>
              <td class="text-right px-1">0</td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2 ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Miscellaneous
          </div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small  font-weight-bold px-1">Miscellaneous Income :</td>
              <td class="text-right small px-1">{{
                currFormat(summaryData.addons_charges_conv)
              }}</td>
            </tr>
          </table>
        </div>

        <div class="col-4 border border-1 border-dark py-2 ">
          <div class="container bg-lightgrey font-weight-bold border border-1 border-dark mb-2 text-center">Concessions
            Profit Performance</div>
          <table class="swc-report-table border border-0">
            <tr>
              <td class="text-left small font-weight-bold  px-1">Profit at Standard Cost :</td>

              <td class="text-right small px-1">{{
                concessionData.cost_goods_sold_conv &&
                concessionData.transactions
                ? currFormat(
                  concessionData.cost_goods_sold_conv *
                  concessionData.transactions
                )
                : 0
              }}</td>
            </tr>

            <tr>
              <td class="text-left small font-weight-bold  px-1 ">Profit % :</td>
              <td class="text-right small  px-1">0</td>
            </tr>
            <tr>
              <td class="text-left small  font-weight-bold  px-1">Profit per Item :</td>
              <td class="text-right small px-1">{{
                getProfitStdCost && summaryData.total_admits
                ? currFormat(getProfitStdCost / summaryData.total_admits)
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1">Profit Per Admit :</td>
              <td class="text-right small px-1">{{
                concessionData.gross_revenue_conv &&
                concessionData.qty_items_sold
                ? currFormat(
                  concessionData.gross_revenue_conv /
                  concessionData.qty_items_sold
                )
                : 0
              }}</td>
            </tr>
            <tr>
              <td class="text-left small font-weight-bold  px-1">Price Per Transaction :</td>
              <td class="text-right small px-1">{{
                concessionData.gross_revenue_conv &&
                concessionData.qty_items_sold
                ? currFormat(
                  concessionData.gross_revenue_conv /
                  concessionData.qty_items_sold
                )
                : 0
              }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center my-2">
        <div class="section-title my-2">Performance Report</div>
        <div v-if="performanceMovieRecords.length > 0"
          class="mr-3 align-self-center d-flex justify-content-end align-items-center">
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->

          <a target="_blank" @click="performanceMovieExcelDownload()" title="Download as Excel" download>
            <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <a target="_blank" @click="getPerformanceRecords('N', 'Y')" title="Download as PDF" download>
            <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <div class="table-scroll">
        <table class="performance-report-table" border="1">
          <thead>
            <tr>
              <td colspan="2"></td>
              <td colspan="3">Audience</td>
              <td colspan="4">
                {{ $t("revenue") }}
              </td>
              <td colspan="2">ATP</td>
            </tr>
            <tr>
              <td>{{ $t("film") }}</td>
              <td>{{ $t("noof") }} {{ $t("show") }}</td>
              <td>{{ $t("admits") }}</td>
              <td>{{ $tc("available", 1) }} {{ $t("capacity") }}</td>
              <td>{{ $t("occupancy") }} %</td>
              <td>BOR</td>
              <td>VAT</td>
              <td>Nett BOR</td>
              <td>BOR ATP</td>
              <td>Net ATP</td>
            </tr>
          </thead>

          <tbody v-if="performanceMovieRecords.length">
            <tr v-for="(PerformanceReportList,
              PerformanceReportListIndex) in performanceMovieRecords" :key="PerformanceReportListIndex">
              <td class="text-left">
                <div>{{ PerformanceReportList.movie_name }}</div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>{{ PerformanceReportList.no_of_show }}</div>
                <!-- <div>8</div>
              <div>12</div>-->
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>{{ PerformanceReportList.admits }}</div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>{{ PerformanceReportList.capacity_total }}</div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>

                <div>
                  {{
                    PerformanceReportList.admits &&
                    PerformanceReportList.capacity_total
                    ? currFormat(
                      ((parseFloat(PerformanceReportList.admits) /
                        parseFloat(PerformanceReportList.capacity_total)) *
                        10000) /
                      100
                    )
                    : 0
                  }}
                </div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>
                  {{ currFormat(PerformanceReportList.gross_amount_conv) }}
                </div>
              </td>
              <!-- New -->
              <td class="text-right">
                <div>&nbsp;</div>

                <div>{{ currFormat(PerformanceReportList["VAT_conv"]) }}</div>
              </td>

              <td class="text-right">
                <div>&nbsp;</div>
                <div>
                  {{
                    PerformanceReportList.net_amount_conv
                    ? currFormat(PerformanceReportList.net_amount_conv)
                    : 0
                  }}
                </div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>
                  {{
                    PerformanceReportList.gross_amount_conv &&
                    PerformanceReportList.admits
                    ? currFormat(
                      PerformanceReportList.gross_amount_conv /
                      PerformanceReportList.admits
                    ) || "-"
                    : 0
                  }}
                </div>
              </td>
              <td class="text-right">
                <div>&nbsp;</div>
                <div>
                  {{
                    PerformanceReportList.net_amount_conv &&
                    PerformanceReportList.admits
                    ? currFormat(
                      PerformanceReportList.net_amount_conv /
                      PerformanceReportList.admits
                    )
                    : 0
                  }}
                </div>
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td>Grand Total</td>
              <td class="text-right">
                {{
                  performanceMovieRecords.reduce(
                    (acc, { no_of_show }) => acc + no_of_show,
                    0
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  performanceMovieRecords.reduce(
                    (acc, { admits }) => acc + admits,
                    0
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  performanceMovieRecords.reduce(
                    (acc, { capacity_total }) => acc + capacity_total,
                    0
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    ((performanceMovieRecords.reduce(
                      (acc, { admits }) => acc + admits,
                      0
                    ) /
                      performanceMovieRecords.reduce(
                        (acc, { capacity_total }) => acc + capacity_total,
                        0
                      )) *
                      10000) /
                    100
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceMovieRecords.reduce(
                      (acc, { gross_amount_conv }) => acc + gross_amount_conv,
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceMovieRecords.reduce(
                      (acc, { VAT_conv }) => acc + VAT_conv,
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceMovieRecords.reduce(
                      (acc, { net_amount_conv }) => acc + net_amount_conv,
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceMovieRecords.reduce(
                      (acc, { gross_amount_conv }) => acc + gross_amount_conv,
                      0
                    ) /
                    performanceMovieRecords.reduce(
                      (acc, { admits }) => acc + admits,
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    performanceMovieRecords.reduce(
                      (acc, { net_amount_conv }) => acc + net_amount_conv,
                      0
                    ) /
                    performanceMovieRecords.reduce(
                      (acc, { admits }) => acc + admits,
                      0
                    )
                  )
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between my-2 align-items-center">
        <div class="section-title my-2">Concession Sales Analysis Report</div>
        <div v-if="performanceMovieRecords.length > 0"
          class="mr-3 align-self-center mb-3 d-flex justify-content-end align-items-center">
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->

          <a target="_blank" @click="concessionExcelDownload()" title="Download as Excel" download>
            <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <a target="_blank" @click="getPerformanceRecords('N', 'Y')" title="Download as PDF" download>
            <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <div class="table-scroll">
        <table class="concession-analysis-table">
          <thead>
            <tr>
              <th colspan="1" style="width:20%">Item</th>
              <th colspan="4">Units</th>
              <th colspan="3">Per 100 Patrons</th>
              <th colspan="4">Value</th>
            </tr>

            <tr>
              <th></th>
              <th>Qty Sold</th>
              <th>Net Price</th>
              <th>Std Profit</th>
              <th>Std Profit %</th>
              <th>Qty</th>
              <th>Sale</th>
              <th>Profit</th>
              <th>Net Sale</th>
              <th>Sale Mix %</th>
              <th>Net Profit</th>
              <th>Profit Mix %</th>
            </tr>
          </thead>
          <tbody class="border-bottom border-dark" v-if="performanceFnbRecords.length">
            <!-- CREATE THIS TR ONLY FIRST TIME -->
            <tr>
              <td>
                <strong>F&B</strong>
              </td>
              <td colspan="11"></td>
            </tr>
          </tbody>
          <template v-if="performanceFnbRecords.length">
            <tbody class="border-bottom border-dark" v-for="(PerformanceConcessionReports,
              PerformanceConcessionReportsIndex) in performanceFnbRecords" :key="PerformanceConcessionReportsIndex"
              :class="'___' + PerformanceConcessionReports.fc_category">
              <tr class="bg-lightgrey font-weight-bold">
                <td>{{ PerformanceConcessionReports.fc_category }}</td>
              </tr>
              <tr v-for="(SingleItem,
                SingleIndex) in PerformanceConcessionReports.FoodCategory" :key="SingleIndex">
                <td>
                  <p v-if="SingleIndex === 0"></p>
                  {{ SingleItem.item_name }}
                </td>
                <td class="text-right">
                  <p v-if="SingleIndex === 0">&nbsp;</p>
                  {{ SingleItem.fst_quantity }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_price"]
                    ? currFormat(SingleItem.net_price_conv)
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["std_profit"]
                    ? currFormat(SingleItem.std_profit_conv)
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["std_profit"] && SingleItem["net_price"]
                    ? currFormat(
                      (SingleItem.std_profit_conv /
                        SingleItem.net_price_conv) *
                      100
                    )
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(
                      (SingleItem.fst_quantity * 100) / summaryData.total_admits
                    ).toFixed(MIN_FRACTION_DIGITS) || 0
                  }}
                </td>

                <td class="text-right">
                  {{
                    (
                      (SingleItem["net_price_conv"] *
                        (SingleItem.fst_quantity * 100)) /
                      summaryData.total_admits
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    (
                      SingleItem["std_profit_conv"] *
                      ((SingleItem.fst_quantity * 100) /
                        summaryData.total_admits)
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_sales_conv"]
                    ? currFormat(SingleItem.net_sales_conv)
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_sales_conv"] &&
                    SingleItem["total_net_sales_conv"]
                    ? currFormat(
                      (SingleItem.net_sales_conv /
                        SingleItem.total_net_sales_conv) *
                      100
                    )
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_profit_conv"]
                    ? currFormat(SingleItem.net_profit_conv)
                    : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_profit_conv"] &&
                    SingleItem["total_std_profit_conv"]
                    ? currFormat(
                      (SingleItem.net_profit_conv /
                        SingleItem.total_std_profit_conv) *
                      100
                    )
                    : ""
                  }}
                </td>
              </tr>
              <tr :key="PerformanceConcessionReportsIndex + 'CategoryTotal'" class="bg-lightgrey font-weight-bold">
                <td>Total:</td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { fst_quantity }) => {
                        return acc + fst_quantity;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { net_price_conv }) => {
                          return acc + net_price_conv;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { std_profit_conv }) => {
                          return acc + std_profit_conv;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { std_profit_conv, net_price_conv }) => {
                          return acc + (std_profit_conv / net_price_conv) * 100;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { fst_quantity }) => {
                        return (
                          acc + (fst_quantity * 100) / summaryData.total_admits
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_price_conv, fst_quantity }) => {
                        return (
                          acc +
                          net_price_conv *
                          ((fst_quantity * 100) / summaryData.total_admits)
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { std_profit_conv, fst_quantity }) => {
                        return (
                          acc +
                          std_profit_conv *
                          ((fst_quantity * 100) / summaryData.total_admits)
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_sales_conv }) => {
                        return acc + net_sales_conv;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_sales_conv, total_net_sales_conv }) => {
                        return (
                          acc + (net_sales_conv / total_net_sales_conv) * 100
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_profit_conv }) => {
                        return acc + net_profit_conv;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_profit_conv, total_std_profit_conv }) => {
                        return (
                          acc + (net_profit_conv / total_std_profit_conv) * 100
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
              </tr>
            </tbody>
            <tbody class="border-bottom border-dark">
              <tr class="bg-lightgrey font-weight-bold">
                <td>
                  <strong>F&amp;B Total</strong>
                </td>

                <td class="text-right">
                  <strong>{{ performanceFnbRecordsTotal.qtySold }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.netPriceConv)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.stdProfitConv)
                  }}</strong>
                </td>

                <td class="text-right">
                  <strong>{{
                    currFormat(
                      performanceFnbRecordsTotal.stdProfitPercentageConv
                    )
                  }}</strong>
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.qtyTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.salesTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.profitTotal) }}
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.netSaleConv)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.saleMixConv)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.netProfitConv)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(performanceFnbRecordsTotal.profitMixConv)
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </template>
          <tbody v-else>
            <tr>
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      ewalletRecords: [],
      summaryData: {},
      boxOfficeData: {},
      concessionData: {},
      performanceMovieRecords: [],
      performanceFnbRecords: [],
      performanceFnbRecordsTotal: {},
      patronsTotal: {
        qtyTotal: 0,
        salesTotal: 0,
        profitTotal: 0,
      },
      excelFilePath: "",
      performancePdf: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() { },
  computed: {
    getPerPatronsTotal() {
      this.performanceFnbRecords.map((x) => {
        x.FoodCategory.map((y) => {
          this.patronsTotal["qtyTotal"] += +parseFloat(
            (y.fst_quantity * 100) / parseFloat(this.summaryData.total_admits)
          );
          this.patronsTotal["salesTotal"] += +parseFloat(
            (y.net_price_conv * (y.fst_quantity * 100)) /
            parseFloat(this.summaryData.total_admits)
          );
          this.patronsTotal["profitTotal"] += +parseFloat(
            (y.std_profit_conv * (y.fst_quantity * 100)) /
            parseFloat(this.summaryData.total_admits)
          );
        });
      });
      return this.patronsTotal;
    },
    getProfitStdCost() {
      let profitValue =
        this.concessionData.cost_goods_sold_conv &&
          this.concessionData.transactions
          ? this.concessionData.cost_goods_sold_conv *
          this.concessionData.transactions
          : 0;
      return profitValue;
    },
  },
  methods: {
    moment,
    performanceMovieExcelDownload() {
      let temp_records = [...this.performanceMovieRecords];
      let temp_arr = [...this.performanceMovieRecords];
      temp_records.map((x) => {
        let obj = { ...x };
        obj["showTotal"] = this.performanceMovieRecords.reduce(
          (acc, { no_of_show }) => acc + no_of_show,
          0
        );
        obj["admitsTotal"] = this.performanceMovieRecords.reduce(
          (acc, { admits }) => acc + admits,
          0
        );
        obj["capacityTotal"] = this.performanceMovieRecords.reduce(
          (acc, { capacity_total }) => acc + capacity_total,
          0
        );
        obj["occupancyTotal"] = this.performanceMovieRecords.reduce(
          (acc, { capacity_total, admits, no_of_show }) =>
            acc +
            (parseFloat(admits) / parseFloat(capacity_total)) *
            parseFloat(no_of_show) *
            100,
          0
        );
        obj["BORTotal"] = this.performanceMovieRecords.reduce(
          (acc, { gross_amount_conv }) => acc + gross_amount_conv,
          0
        );
      });
      let data = [
        {
          sheet: "FilmWiseCollection Report",
          columns: [
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "no_of_show",
              label: "No of Show",
            },
            {
              value: "admits",
              label: "Admits",
            },
            {
              value: "capacity_total",
              label: "Screen Capacity",
            },
            {
              value: (row) =>
                row.admits && row.capacity_total && row.no_of_show
                  ? parseFloat(
                    (row.admits / row.capacity_total) * 100
                  ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0,
              label: "Occupancy Percentage",
            },
            {
              value: "gross_amount_conv",
              label: "BOR",
            },
            {
              value: (row) =>
                row.GCAM ? parseFloat(row.GCAM).toFixed(MIN_FRACTION_DIGITS) : 0,
              label: "GCAM",
            },
            {
              value: (row) => parseFloat(row.VAT_conv).toFixed(MIN_FRACTION_DIGITS),
              label: "VAT",
            },
            {
              value: (row) =>
                parseFloat(
                  row.net_amount_conv ? row.net_amount_conv.toFixed(MIN_FRACTION_DIGITS) : 0.0
                ),
              label: "Net BOR",
            },
            {
              value: (row) =>
                row.gross_amount_conv && row.admits
                  ? parseFloat(row.gross_amount_conv / row.admits).toFixed(MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "BOR ATP",
            },
            {
              value: (row) =>
                row.net_amount_conv && row.admits
                  ? parseFloat(row.net_amount_conv / row.admits).toFixed(MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "NET ATP",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_arr,
        },
      ];
      let settings = {
        fileName: `Performance&SummaryReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    concessionExcelDownload() {
      let temp_obj = this.performanceFnbRecords;
      let temp_arr = [];
      temp_obj.map((x) => {
        x.FoodCategory.map((y) => {
          let obj = { ...x, ...y, ...this.summaryData };
          temp_arr.push(obj);
        });
      });
      let data = [
        {
          sheet: "Concession Sales Report",
          columns: [
            {
              value: "item_name",
              label: "Item Name",
            },
            {
              value: "fst_quantity",
              label: "Qty Sold",
            },
            {
              value: (row) =>
                row.net_price_conv
                  ? +parseFloat(row.net_price_conv).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Net Price",
            },
            {
              value: (row) =>
                row.std_profit_conv
                  ? +parseFloat(row.std_profit_conv).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Std Profit",
            },

            {
              value: (row) =>
                row.fst_quantity
                  ? +parseFloat(
                    (row.fst_quantity * 100) / row.total_admits
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Qty Per 100 Patrons",
            },
            {
              value: (row) =>
                row.net_price_conv
                  ? +parseFloat(
                    row.net_price_conv *
                    ((row.fst_quantity * 100) / row.total_admits)
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Sales Per 100 Patrons",
            },
            {
              value: (row) =>
                row.std_profit_conv
                  ? +parseFloat(
                    row.std_profit_conv *
                    ((row.fst_quantity * 100) / row.total_admits)
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Profit Per 100 Patrons",
            },
            {
              value: (row) =>
                row.std_profit_conv && row.net_price_conv
                  ? +parseFloat(
                    (row.std_profit_conv / row.net_price_conv) * 100
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : 0,
              label: "Std Profit %",
            },
            {
              value: (row) =>
                row.net_sales_conv
                  ? +parseFloat(row.net_sales_conv).toFixed(MIN_FRACTION_DIGITS)
                  : "-",
              label: "Net Sale",
            },
            {
              value: (row) =>
                row.net_sales_conv && row.total_net_sales_conv
                  ? +parseFloat(
                    (row.net_sales_conv / row.total_net_sales_conv) * 100
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "Sale Mix %",
            },
            {
              value: (row) => +parseFloat(row.net_profit_conv).toFixed(MIN_FRACTION_DIGITS),
              label: "Net Profit",
            },
            {
              value: (row) =>
                row.net_profit_conv && row.total_std_profit_conv
                  ? +parseFloat(
                    (+parseFloat(row.net_profit_conv) /
                      +parseFloat(row.total_std_profit_conv)) *
                    100
                  ).toFixed(MIN_FRACTION_DIGITS)
                  : 0.0,
              label: "Profit Mix %",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_arr,
        },
      ];
      let settings = {
        fileName: `ConcessionReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getSummaryPerformanceData: async function () {
      Promise.all([
        this.getSummaryReport("N"),
        this.getPerformanceRecords(),
      ]).then(() => { });
    },
    getEWalletReport(isExcel = "N", isPdf = "N") {
      this.ewalletRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetEWalletReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.ewalletRecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getSummaryReport(isPdf = "N") {
      this.summaryData = {};
      this.boxOfficeData = {};
      this.concessionData = {};
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }

      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsService.GetSummaryV4(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records) {
            this.summaryData = { ...data.Records.summary };
            this.boxOfficeData = { ...data.Records.boxOffice };
            this.concessionData = { ...data.Records.concession };
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          }
          this.$toasted.show(data.message);
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getPerformanceRecords(isExcel = "N", isPdf = "N") {
      this.performanceMovieRecords = [];
      this.performanceFnbRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsServiceV2.getPerformanceReportLebanon(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.performanceMovieRecords = [...data.Records];
            this.performanceFnbRecords = [...data.FinalConcessionRecords];
            this.performanceFnbRecordsTotal = {
              ...data.FinalConcessionRecordsTotal,
            };
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.PDFName) {
              window.open(`${BASEURL}${data.PDFName}`, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/summaryAndPerformanceV4.vue